import type { CountryCode } from '@insify/global-countries';

// TODO move address-related types to some global package because we just keep copying them over and over
type GeoLocation = {
  latitude: string;
  longitude: string;
};
export type Address = {
  street: string;
  streetAddition?: string;
  houseNumber: string;
  houseNumberAddition?: string;
  postalCode?: string;
  province?: string;
  city: string;
  country: CountryCode;
  geoLocation?: GeoLocation;
};

type AddressComponent = {
  long_name: string;
  short_name: string;
  types: string[];
};

const mapAddressComponentsToAddress = (
  addressComponents: AddressComponent[],
  onPostalcodeMissing?: (postalCode: string | undefined) => void,
): Partial<Address> => {
  const streetNumber = addressComponents.find((component) => component.types.includes('street_number'))?.long_name;
  const [_, houseNumber, houseNumberAddition] = streetNumber?.match(/^(\d+) ?([a-z]*)$/i) ?? [];

  const country = addressComponents.find((component) => component.types.includes('country'))?.short_name as CountryCode;

  const postalCode = addressComponents.find((component) => component.types.includes('postal_code'))?.long_name;

  if (postalCode === undefined || postalCode === '') {
    onPostalcodeMissing?.(postalCode);
  }

  const dict = {
    street: addressComponents.find((component) => component.types.includes('route'))?.long_name,
    houseNumber,
    houseNumberAddition: houseNumberAddition !== '' ? houseNumberAddition : undefined,
    postalCode: formatPostalCode(country, postalCode ?? ''),
    province: addressComponents.find((component) => component.types.includes('administrative_area_level_1'))?.long_name,
    city: addressComponents.find((component) => component.types.includes('locality'))?.long_name,
    country,
  };

  return Object.fromEntries(Object.entries(dict).filter(([, value]) => value !== undefined));
};

const formatPostalCode = (country: string, postalCode: string): string => {
  if (country === 'NL') {
    const NLPostalCodeRegex = /^(\d{4})\s*?([A-Z]{2})$/;
    const formattedPostalCode = postalCode.split(',')[0].trim();
    const result = NLPostalCodeRegex.exec(formattedPostalCode);
    if (!result || result.length <= 2) {
      return postalCode;
    }

    return result[1] + result[2];
  }

  return postalCode;
};

export { mapAddressComponentsToAddress };
